import React, { Component }   from 'react'
import PropTypes              from 'prop-types'
import {getMajors, getSpecial, getStatisticsSpecial,getRecommendMajor,} from '../../api/major';
import {getRecommendation, getXkCoachBasic, saveSpecialtyIntention, saveXkCoachBasic} from "../../api/majorWishList";

import { MajorSelect } from 'shijie_npm2';
import 'shijie_npm2/dist/main.css';

// 保存意向专业后 跳转学生站首页
import { studentOrigin } from "../../constants/constants";

class MajorList extends Component {

  static propTypes = {
    disabledOperation: PropTypes.bool,
    codes: PropTypes.array,
    changeCodes: PropTypes.func,
  }

  state = {
  }

  goBack() {
    window.history.back()
  }

  goHome() {
    window.location.href=`${studentOrigin}/xkCoach/home`
  }

  goToDetail(majorId) {
    const { history } = this.props;
    history.push(`/xkcoach/majorwishlist/major/${majorId}`)
  }

  async getMajors(value) {
    // 搜索专业用参数模板 post(`/xbag/college/specialty/gets`, param, true)
    const paramReset = {
      limit: 9999,
      page: 1,
      _s_name: null,
      _s_types:'20',//20本科  60本科标签
    };

    const param = {
      ...paramReset,
      _s_name: value,
    };

    return await getMajors(param);
  }

  componentDidMount() {
  }

  render() {
    const { disabledOperation, codes, changeCodes } = this.props;
    return <MajorSelect
      disabledOperation={disabledOperation}
      codes={codes}
      changeCodes={changeCodes}
      scene="mobile"
      userType="wechat"
      getMajors={this.getMajors.bind(this)}
      goBack={this.goBack.bind(this)}
      goHome={this.goHome.bind(this)}
      goToDetail={this.goToDetail.bind(this)}
      getSpecial={getSpecial}
      getStatisticsSpecial={getStatisticsSpecial}
      getRecommendMajor={getRecommendMajor}
      getRecommendation={getRecommendation}
      getXkCoachBasic={getXkCoachBasic}
      saveSpecialtyIntention={saveSpecialtyIntention}
      saveXkCoachBasic={saveXkCoachBasic}
    ></MajorSelect>
  }
}

export default MajorList



// WEBPACK FOOTER //
// ./src/pages/MajorWishListNew/Choose.js